import { useEffect, useRef } from "react";

import { StyledTextfield, StyledTextfieldWrapper, StyledActionWrapper } from "./styles";

type TextfieldProps = {
    value: string | undefined;
    placeholder?: string;
    isLocked?: boolean;
    isDisabled?: boolean;
    autoFocus?: boolean;
    isFocused?: boolean;
    onChange: (value: string | undefined) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    actionButton?: React.ReactNode;
};

const GradientTextfield = ({
    value,
    isLocked = false,
    isDisabled = false,
    placeholder,
    autoFocus,
    isFocused,
    onChange,
    onKeyDown,
    actionButton,
}: TextfieldProps) => {
    const inputRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (isFocused) {
            inputRef.current?.focus();
        }
    }, [isFocused]);

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = event.target.value;
        onChange(newValue);
    };

    const textarea = (
        <StyledTextfield
            ref={inputRef}
            value={value}
            onChange={handleChange}
            onKeyDown={(event) => onKeyDown?.(event)}
            placeholder={placeholder}
            $isLocked={isLocked}
            $isDisabled={isDisabled}
            disabled={isLocked || isDisabled}
            autoFocus={autoFocus}
            rows={1}
            $hasAction={!!actionButton}
        />
    );

    if (!actionButton) {
        return textarea;
    }

    return (
        <StyledTextfieldWrapper>
            {textarea}
            <StyledActionWrapper>{actionButton}</StyledActionWrapper>
        </StyledTextfieldWrapper>
    );
};

export default GradientTextfield;
